import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  IUserPreferencesDialogData,
  RemoteControlUserPreferencesDialogComponent,
} from 'xsmodules/remote-control/remote-control-view/remote-control-user-preferences/rc-user-preferences-dialog/rc-user-preferences-dialog.component';

@Component({
  selector: 'app-remote-control-user-preferences',
  templateUrl: './remote-control-user-preferences.component.html',
  styleUrls: ['./remote-control-user-preferences.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RemoteControlUserPreferencesComponent implements OnInit {
  @Input() isVideoRecordingDisabled: boolean;
  @Input() isDisabled: boolean;
  @Input() isScreenSettingsVisible: boolean;

  constructor(private dialog: MatDialog) {}

  ngOnInit() {}

  public openUserPreferences() {
    if (!this.isDisabled) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = 'RemoteControlUserPreferencesDialog';
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
      dialogConfig.width = '580px';
      dialogConfig.data = {
        isVideoRecordingDisabled: this.isVideoRecordingDisabled,
        isScreenSettingsVisible: this.isScreenSettingsVisible,
      } as IUserPreferencesDialogData;
      this.dialog.open(RemoteControlUserPreferencesDialogComponent, dialogConfig);
    }
  }
}
